import { render, staticRenderFns } from "./vsInputNumber.vue?vue&type=template&id=ecaa5d0a&lang=html&"
import script from "./vsInputNumber.vue?vue&type=script&lang=js&"
export * from "./vsInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsInputNumber.vue"
export default component.exports